import { AccessoryCategoryEnum } from '../../../../api/models/accessory-category-enum';

export const ProductTypeMap: any = {
  '': 'Accesorii',
  [AccessoryCategoryEnum.SimpleAccessory]: 'Accesorii',
  [AccessoryCategoryEnum.Accessory]: 'Accesorii',
  [AccessoryCategoryEnum.RainSystem]: 'Sistem pluvial',
  [AccessoryCategoryEnum.FenceSlats]: 'Gard',
};
